/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { openPage } from '@/plugins/analytics';

Vue.use(VueRouter);

const router = new VueRouter({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: window.myConfig.BASE_URL,
});

router.beforeEach((to, from, next) => {
  openPage(to);

  next();
});

// регистронезависимые роуты
router.history.getCurrentLocation = () => {
  let path = window.location.pathname;
  let base = router.history.base;

  // Removes base from path (case-insensitive)
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash;
};
export default router;
